import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";

export class PriceLevelScheduleDiscontinueAction {
    constructor(public priceLevelScheduleId: number) {
    }
}

/**
 * Action Service to discontinue a price level schedule
 */
@Injectable()
export class PriceLevelScheduleDiscontinueService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "price-level-schedule-discontinue");
    }
}
